import {eventBus} from '@/common/events';

export const modal = {
    install: (app: any): void => {
        app.config.globalProperties.$modal = {
            open(id = '', {data = {}, options = {}} = {}) {
                eventBus.emit('missions-events:modal:open', {id, data, options});
            },
            close(id = '', {data = {}, options = {}} = {}) {
                eventBus.emit('missions-events:modal:closed', {id, data, options});
            },
        };
    },
};
